import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cn } from "../../lib/utils";

// The template's separator (next-shadcn-admin-dashboard/src/components/ui/
// separator.tsx at bff60d4), ported by hand: Helix's Radix import and `cn`.
// The data-horizontal / data-vertical variants come from shadcn/tailwind.css
// (styles.css). Record: docs/testing/ui-migration/009-ui-separator.md.
function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch",
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
